import { render } from "./link-type-popup.vue?vue&type=template&id=354d05ec"
import script from "./link-type-popup.vue?vue&type=script&lang=js"
export * from "./link-type-popup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__